import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="w-full max-w-md border-2 border-black bg-white shadow-brutLg">
            <div className="border-b-2 border-black p-6 bg-signal/10 flex items-center gap-3">
              <AlertTriangle size={24} strokeWidth={2.5} className="text-signal" />
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-black/60">[ ERROR ]</div>
                <h2 className="font-heading font-black text-xl uppercase tracking-tight">Terjadi Kesalahan</h2>
              </div>
            </div>
            <div className="p-6 space-y-4">
              <p className="font-mono text-sm text-black/70">
                Aplikasi mengalami masalah yang tidak terduga. Silakan muat ulang halaman atau kembali ke dasbor.
              </p>
              {this.state.error && (
                <div className="bg-[#F0F0F0] border border-black/20 p-3 font-mono text-[11px] text-black/60 break-all max-h-24 overflow-y-auto">
                  {this.state.error.message || "Unknown error"}
                </div>
              )}
              <div className="flex gap-3 pt-2">
                <button
                  onClick={() => window.location.reload()}
                  data-testid="error-reload-btn"
                  className="flex-1 bg-black text-white border-2 border-black px-4 py-3 font-mono uppercase text-xs tracking-wider btn-brut hover:bg-klein hover:-translate-y-0.5 hover:shadow-brut flex items-center justify-center gap-2"
                >
                  <RefreshCw size={14} strokeWidth={2.5} /> Muat Ulang
                </button>
                <button
                  onClick={() => { window.location.href = "/dashboard"; }}
                  data-testid="error-home-btn"
                  className="flex-1 bg-white text-black border-2 border-black px-4 py-3 font-mono uppercase text-xs tracking-wider btn-brut hover:bg-canary hover:-translate-y-0.5 hover:shadow-brut flex items-center justify-center gap-2"
                >
                  <Home size={14} strokeWidth={2.5} /> Dasbor
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
